// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"063e6576","424":"d74e7fb4"}[chunkId] + ".chunk.css";
};